/**
 * Formata uma data para o padrão brasileiro (DD/MM/YYYY)
 */
export const formatDate = (date: Date | string | number | null | undefined): string => {
  if (!date) return "";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("pt-BR");
};

/**
 * Formata uma data e hora para o padrão brasileiro (DD/MM/YYYY HH:mm:ss)
 */
export const formatDateTime = (date: Date | string | number | null | undefined): string => {
  if (!date) return "";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleString("pt-BR");
};
